module.exports = __webpack_public_path__ + "media/components/stylesheets/BrandonText-Regular-03d5698b64ee890cf20a2c1e1e671213.woff2";